"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatchFactorDescription = void 0;

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var MatchFactorDescription = function MatchFactorDescription() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      children: "The MatchFactor score is determined by Nav using data Nav has available for your business and how well that data aligns with the minimum requirements for each offer. It is not an assessment of approval odds."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_baseReactComponents.Copy, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "90% - 99%:"
      }), " The qualifications you provided align with the minimum requirements for this offer."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_baseReactComponents.Copy, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "80% - 89%:"
      }), " Most of your qualifications align with the minimum requirements for this offer, we recommend verifying all of your data before you apply."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_baseReactComponents.Copy, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "50% - 79%:"
      }), " We either need more data from you to verify your qualifications or your qualifications do not align with the minimum requirements for this offer. We recommend verifying all of your data and looking for offers that are a better fit before you apply."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_baseReactComponents.Copy, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
        children: "Less than 50%:"
      }), " Based on the qualifications you provided, you do not meet the minimum requirements to get approved for this offer. We recommend verifying all of your data, looking for offers that are a better fit, and taking action to improve your qualifications."]
    })]
  });
};

exports.MatchFactorDescription = MatchFactorDescription;
//# sourceMappingURL=match-factor-description.js.map